import {
  SET_FORCE_LOGOUT,
  SET_LOGOUT,
  INITIALIZE_RESET,
  SET_PASSWORD_EXPIRED,
  CLEAR_PASSWORD_EXPIRED,
} from './constants';
import { logoutUser } from '../utils/utils';

const handleLogout = (isForced) => (dispatch) => {
  // Dispatch the action. This will tell the app that use will soon be logged out
  if (isForced) {
    dispatch({
      type: SET_FORCE_LOGOUT,
    });
  } else {
    dispatch({
      type: SET_LOGOUT,
    });
  }

  dispatch({
    type: INITIALIZE_RESET,
  });

  // Now logout the user
  logoutUser(!isForced);
};

export const setForceLogout = () => handleLogout(true);
export const setLogout = () => handleLogout(false);

export const setPasswordExpired = () => (dispatch) => {
  // Persist a marker so the flag survives a page refresh — re-hydrated by
  // logoutReducer's module-load-time check.
  try {
    window.localStorage.setItem('passwordExpired', '1');
  } catch {
    // localStorage may be unavailable (private mode, etc.) — non-fatal.
  }
  dispatch({ type: SET_PASSWORD_EXPIRED });
};

export const clearPasswordExpired = () => (dispatch) => {
  try {
    window.localStorage.removeItem('passwordExpired');
  } catch {
    // localStorage may be unavailable (private mode, etc.) — non-fatal.
  }
  dispatch({ type: CLEAR_PASSWORD_EXPIRED });
};
